module.exports = __webpack_public_path__ + "static/media/duracell.c15cce6f.svg";